module.exports = __webpack_public_path__ + "img/letaa_al_ayad_yes.bed6d598.png";